module.exports = __webpack_public_path__ + "img/3-5.035a69aa.svg";